module.exports = __webpack_public_path__ + "media/18.b63dc4b9.wav";